import { PackType } from '../types/api/request/packpickrequest';

export const PACK_TYPE_OPTIONS: { value: PackType; label: string }[] = [
  { value: 'WRAP', label: 'Wrap' },
  { value: 'PAPER_BAG', label: 'Paper Bag' },
  { value: 'SMALL_CARTON', label: 'Small Carton' },
  { value: 'BIG_CARTON', label: 'Big Carton' },
  { value: 'BULKY', label: 'Bulky (no packaging)' },
];

// Falls back to the raw value so an unknown type from the backend still shows something.
export const getPackTypeLabel = (type: string) =>
  PACK_TYPE_OPTIONS.find((o) => o.value === type)?.label ?? type;
